import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
        <li>
          <Link to="/" className="flex items-center gap-1 transition-colors hover:text-primary-600">
            <i className="ri-home-4-line"></i>
            <span>首页</span>
          </Link>
        </li>
        {items.map((c, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
            {c.to ? (
              <Link to={c.to} className="transition-colors hover:text-primary-600">
                {c.label}
              </Link>
            ) : (
              <span className="text-foreground-950" aria-current="page">
                {c.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}